import axios from 'axios';

export const listGconSessions = () => axios.get('/v1/gcon/sessions/', { params: { limit: 200 } });

export const getGconSession = id => axios.get(`/v1/gcon/sessions/${id}/`);

export const createGconSession = (gconInputs, gconOutputs) => {
  const form = new FormData();
  gconInputs.forEach(f => form.append('gcon_input', f));
  gconOutputs.forEach(f => form.append('gcon_output', f));
  return axios.post('/v1/gcon/sessions/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const renameGconSession = (id, name) => axios.patch(`/v1/gcon/sessions/${id}/`, { name });

export const updateGconSessionTargets = (id, bopTargets) =>
  axios.patch(`/v1/gcon/sessions/${id}/`, { bop_targets: bopTargets });

export const deleteGconSession = id => axios.delete(`/v1/gcon/sessions/${id}/`);

export const getGconSessionInsights = (sessionId, key) =>
  axios.get(`/v1/gcon/sessions/${sessionId}/insights/`, { params: { key } });

export const generateGconSessionInsights = (sessionId, key, analysis) =>
  axios.post(`/v1/gcon/sessions/${sessionId}/insights/`, { key, analysis });

export const getGconChat = sessionId => axios.get(`/v1/gcon/sessions/${sessionId}/chat/`);

export const sendGconChat = (sessionId, message, context) =>
  axios.post(`/v1/gcon/sessions/${sessionId}/chat/`, { message, context });

export const clearGconChat = sessionId => axios.delete(`/v1/gcon/sessions/${sessionId}/chat/`);
